import * as React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import DynamicFullLogo from '#/shared/components/DynamicFullLogo';
import { BUS_FX_MODE, LIGHT_RAIL_MODE, RAIL_MODE } from '#/shared/constants';
import * as Styled from './styled';

// TODO: import from constants and add in 'BUS_FX_MODE' in vehicle array on September 17, 2022
const vehicles = [BUS_FX_MODE, LIGHT_RAIL_MODE, RAIL_MODE];

function BrandFooter({ inverse }) {
  const intl = useIntl();

  return (
    <Styled.BrandFooterWrap inverse={inverse}>
      <Styled.BrandFooter>
        <Styled.VehicleIconsRow>
          {vehicles.map(v => {
            return (
              <Styled.VehicleCol key={v}>
                <Styled.VehicleIcon mode={v} />
              </Styled.VehicleCol>
            );
          })}
        </Styled.VehicleIconsRow>
        <Styled.LogoRow>
          <DynamicFullLogo
            inverse={inverse}
            title={intl.formatMessage({
              id: 'arrivals.trimet-full-logo-title',
            })}
          />
        </Styled.LogoRow>
      </Styled.BrandFooter>
    </Styled.BrandFooterWrap>
  );
}

BrandFooter.propTypes = {
  /** Whether to apply component's inverse color scheme */
  inverse: PropTypes.bool,
};

BrandFooter.defaultProps = {
  inverse: false,
};

export default BrandFooter;
